import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ProgramBottleneckFormComponent } from '../program-bottleneck-form/program-bottleneck-form.component';
import { ToolListService } from '@/shared/services/tool-list.service';

@Component({
  selector: 'program-bottleneck-page',
  templateUrl: './program-bottleneck-page.component.html',
  styleUrls: ['./program-bottleneck-page.component.css'],
  standalone: false,
})
export class ProgramBottleneckPageComponent {
  constructor(
    public dialog: MatDialog,
    public toolListService: ToolListService,
  ) {}

  // open pop up dialog when in mobile mode if filter is clicked
  openDialog() {
    this.dialog.open(ProgramBottleneckFormComponent);
  }
}
